import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import packageJson from '../../../package.json';
const year = new Date().getFullYear();

function Footer() {
  const [primaryMenu] = useState([
    {
      id: 1,
      name: "AutoCheck Terms and Conditions",
      link: "/terms-conditions",
      target: "_self",
    },
    {
      id: 2,
      name: "Experian Terms and Conditions",
      link: "https://www.experian.com/corporate/legalterms?cmpid=auto_web_acmembers_hp",
      target: "_blank",
    },
    {
      id: 3,
      name: "Privacy Policy",
      link: "https://www.experian.com/privacy/auto_check?cmpid=auto_web_acmembers_hp",
      target: "_blank",
    },
    {
      id: 4,
      name: "Patent Notice",
      link: "/patent-notice",
      target: "_self",
    },
  ]);
  const [nmvtisMenu] = useState([
    {
      id: 2,
      name: "Experian Terms and Conditions",
      link: "https://www.experian.com/corporate/legalterms?cmpid=auto_web_acmembers_hp",
      target: "_blank",
    },
    {
      id: 3,
      name: "Privacy Policy",
      link: "https://www.experian.com/privacy/auto_check?cmpid=auto_web_acmembers_hp",
      target: "_blank",
    }
  ]);

   // Track loginType as state so React can re-render when it changes
  const [loginType, setLoginType] = useState(localStorage.getItem("loginType"));

  useEffect(() => {
    // Listen for localStorage changes from other tabs/windows
    const handleStorage = (e) => {
      if (e.key === "loginType") {
        setLoginType(e.newValue);
      }
    };
    window.addEventListener("storage", handleStorage);

    // Optionally, poll for changes in the same tab (if you change loginType elsewhere in your app)
    const interval = setInterval(() => {
      const currentLoginType = localStorage.getItem("loginType");
      if (currentLoginType !== loginType) {
        setLoginType(currentLoginType);
      }
    }, 500);

    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(interval);
    };
  }, [loginType]);

  // Dynamically select menu based on loginType
  const menu = loginType === "nmvtis" ? nmvtisMenu : primaryMenu;

  const renderFooterLinks = () => {
  return (
    <ul>
      {menu.map((data) =>
        data.target === "_blank" ? (
          <li key={data.id}>
            <a
              href={data.link}
              target="_blank"
              rel="noopener noreferrer"
              className="foot-text text-decoration-none"
            >
              {data.name}
            </a>
          </li>
        ) : (
          <li key={data.id}>
            <Link
              to={data.link}
              target={data.target}
              className="foot-text text-decoration-none"
            >
              {data.name}
            </Link>
          </li>
        )
      )}
    </ul>
  );
};

  const renderCopyright = () => (
    <div className="copyright pt-4 mb-4">
      <div className="container text-center">
        <div className="row">
          <div className="col-sm-12">
            <p>
              <small>
                ©<span>{year}</span> Experian Information Solutions, Inc. All
                rights reserved.
              </small>
            </p>
            <p>
              <small>
                Experian and the Experian trademarks used herein are
                trademarks or registered trademarks of Experian. Other product
                or company names mentioned herein are the property of their
                respective owners.
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <footer id="memberFooter">
      <div id="local-footer" className="container-fluid text-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              {renderFooterLinks()}
            </div>
          </div>
        </div>
      </div>
      {renderCopyright()}
    </footer>
  );
}

export default Footer;